<template>
  <ServicePageLayout
    title="Electrical"
    subtitle="ระบบไฟฟ้า"
    icon="mdi-lightning-bolt-circle"
    breadcrumb="Operations"
    :available="main_meter.length > 0"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab>Dashboard</v-tab>
      <v-tab>Main Distribution Panel</v-tab>
      <v-tab>History</v-tab>
      <v-tab>Monitor</v-tab>
      <v-tab>Machine</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><Dashboard /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><Diagram /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><Table /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><Analytic /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><MACHINE_VIEW :assets="ee_machine" /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import Diagram from '@/components/electrical/electrical_diagram'
import Dashboard from '@/components/electrical/electrical_dashboard'
import Analytic from '@/components/electrical/electrical_analytic'
import Table from '@/components/electrical/electrical_table'
import MACHINE_VIEW from '@/components/machine/machine_view'

export default {
  name: 'ElectricalView',
  components: {
    ServicePageLayout,
    Diagram,
    Dashboard,
    Analytic,
    Table,
    MACHINE_VIEW
  },
  computed: {
    main_meter() {
      return this.$store.state.Energy.mainMeter
    },
    ee_machine() {
      return this.$store.state.Asset.assetAll.filter(
        el => el.machine === true && el.serviceId === '20340ea6-88dd-11ee-b9d1-0242ac120003'
      )
    }
  },
  data() {
    return {
      tab: null,
      change: false
    }
  },
}
</script>
